/**
 * FC トップ: HASAM お知らせスタック（位置固定・z-index + 切り替えアニメーション）
 * 左＝過去 / 右＝未来・index 0 が最新・端でループ
 */
(function () {
  var root = document.querySelector('[data-hasam-notice-carousel]');
  if (!root) return;

  var stack = root.querySelector('[data-hasam-notice-stack]');
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hasam-notice-panel]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hasam-notice-dot]'));
  var prevBtn = root.querySelector('[data-hasam-notice-prev]');
  var nextBtn = root.querySelector('[data-hasam-notice-next]');
  var total = panels.length;
  var activeIndex = 0;
  var isAnimating = false;
  var swipeStartX = 0;
  var swipeStartY = 0;
  var swipeTracking = false;
  var swipeTextEl = null;
  var swipeTextScrollTopStart = 0;
  var SWIPE_MIN = 40;
  var SCROLL_DELTA_MIN = 2;
  var ANIM_MS = 420;
  var swipeMql = window.matchMedia('(max-width: 749px)');
  var reducedMotionMql = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (total === 0) return;

  function stackDistance(index) {
    return (index - activeIndex + total) % total;
  }

  function findTextFromTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest('.fc-hasam-notice__text');
  }

  function isTextScrollable(textEl) {
    return textEl && textEl.scrollHeight > textEl.clientHeight + 1;
  }

  function resetSwipeTouchState() {
    swipeTracking = false;
    swipeTextEl = null;
    swipeTextScrollTopStart = 0;
  }

  function setArrowState(button, disabled) {
    if (!button) return;
    button.disabled = disabled;
    button.classList.toggle('is-disabled', disabled);
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function updateArrows() {
    setArrowState(nextBtn, activeIndex <= 0);
    setArrowState(prevBtn, false);
  }

  function clearPanelMotionClasses() {
    panels.forEach(function (panel) {
      panel.classList.remove('is-revealing');
    });
  }

  function syncDots() {
    dots.forEach(function (dot, index) {
      var isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function applyStackState() {
    panels.forEach(function (panel, index) {
      var distance = stackDistance(index);
      var isFront = distance === 0;

      panel.style.zIndex = String(total - distance);
      panel.classList.toggle('is-active', isFront);

      if (isFront) {
        panel.removeAttribute('aria-hidden');
      } else {
        panel.setAttribute('aria-hidden', 'true');
      }
    });
    syncDots();
    updateArrows();
  }

  function getDirection(fromIndex, toIndex) {
    if (fromIndex === toIndex) return 'jump';
    var forward = (toIndex - fromIndex + total) % total;
    var backward = (fromIndex - toIndex + total) % total;
    if (forward < backward) return 'past';
    if (backward < forward) return 'future';
    return 'jump';
  }

  function finishMotion(nextPanel) {
    if (nextPanel) nextPanel.classList.remove('is-revealing');
    root.removeAttribute('data-nav-direction');
    isAnimating = false;
  }

  function navigateTo(nextIndex, direction, animate) {
    if (nextIndex < 0 || nextIndex >= total) return;
    if (nextIndex === activeIndex) return;
    if (isAnimating) return;

    var nextPanel = panels[nextIndex];
    var shouldAnimate = animate && total > 1 && !reducedMotionMql.matches;

    activeIndex = nextIndex;
    applyStackState();

    if (!shouldAnimate) {
      clearPanelMotionClasses();
      root.removeAttribute('data-nav-direction');
      return;
    }

    isAnimating = true;
    root.setAttribute('data-nav-direction', direction);

    clearPanelMotionClasses();
    if (nextPanel) {
      void nextPanel.offsetWidth;
      nextPanel.classList.add('is-revealing');
    }

    window.setTimeout(function () {
      finishMotion(nextPanel);
    }, ANIM_MS);
  }

  function goTo(index, animate) {
    navigateTo(index, getDirection(activeIndex, index), animate !== false);
  }

  function goPast() {
    navigateTo((activeIndex + 1) % total, 'past', true);
  }

  function goFuture() {
    if (activeIndex <= 0) return;
    navigateTo(activeIndex - 1, 'future', true);
  }

  function shouldIgnoreSwipeForTextScroll(textEl, deltaX, deltaY) {
    if (!isTextScrollable(textEl)) return false;

    var scrolled = Math.abs(textEl.scrollTop - swipeTextScrollTopStart) > SCROLL_DELTA_MIN;
    if (scrolled) return true;

    return Math.abs(deltaY) >= Math.abs(deltaX);
  }

  function onTouchStart(event) {
    if (!swipeMql.matches || total <= 1) return;
    var touch = event.touches[0] || event.changedTouches[0];
    if (!touch) return;
    swipeStartX = touch.clientX;
    swipeStartY = touch.clientY;
    swipeTracking = true;
    swipeTextEl = findTextFromTarget(event.target);
    swipeTextScrollTopStart = swipeTextEl ? swipeTextEl.scrollTop : 0;
  }

  function onTouchEnd(event) {
    if (!swipeTracking) return;
    if (!swipeMql.matches || total <= 1) {
      resetSwipeTouchState();
      return;
    }

    var touch = event.changedTouches[0];
    if (!touch) {
      resetSwipeTouchState();
      return;
    }

    var deltaX = touch.clientX - swipeStartX;
    var deltaY = touch.clientY - swipeStartY;

    if (swipeTextEl && shouldIgnoreSwipeForTextScroll(swipeTextEl, deltaX, deltaY)) {
      resetSwipeTouchState();
      return;
    }

    resetSwipeTouchState();

    if (Math.abs(deltaX) < SWIPE_MIN || Math.abs(deltaX) < Math.abs(deltaY)) return;

    if (deltaX < 0) {
      if (activeIndex > 0) goFuture();
    } else {
      goPast();
    }
  }

  if (total > 1) {
    if (prevBtn) {
      prevBtn.disabled = false;
      prevBtn.classList.remove('is-disabled');
      prevBtn.setAttribute('aria-disabled', 'false');
      prevBtn.addEventListener('click', goPast);
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', goFuture);
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(index)) goTo(index, true);
      });
    });

    if (stack) {
      stack.addEventListener('touchstart', onTouchStart, { passive: true });
      stack.addEventListener('touchend', onTouchEnd, { passive: true });
      stack.addEventListener('touchcancel', resetSwipeTouchState);
    }
  }

  applyStackState();
})();
